// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Replace with your Firebase config (from step 2)
const firebaseConfig = {
  apiKey: "AIzaSyA9OAjddbrggOjDClcPekiMjElW6rRhm_M",
  authDomain: "ym-the-wedding.firebaseapp.com",
  projectId: "ym-the-wedding",
  storageBucket: "ym-the-wedding.firebasestorage.app",
  messagingSenderId: "86848101223",
  appId: "1:86848101223:web:92ccd8359cbe82eb22adc2"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };